import React from 'react';
import { 
  Box, 
  Typography, 
  Paper, 
  Grid,
  Avatar
} from '@mui/material';
import AutoAwesomeIcon from '@mui/icons-material/AutoAwesome';

interface FeedBackAndSummaryProps {
  evaluationDetails?: any;
}

const FeedBackAndSummary: React.FC<FeedBackAndSummaryProps> = ({ evaluationDetails }) => {

  const sections = [
    { title: "Strengths", key: "match_strengths" },
    { title: "Match Gaps", key: "match_gaps" },
    { title: "Recommendations", key: "recommendation" },
    { title: "Growth Potential", key: "growth_potential" },
    { title: "Risk Factors", key: "risk_factors" },
    { title: "Cultural Fit", key: "cultural_fit" },
    { title: "Interview / Evaluation focus", key: "interview_focus" },
    { title: "Comments", key: "comments" }
  ];

  return (
    <Box>
    
      {sections.map((section, index) => {
        const content = evaluationDetails?.[section.key];
        if (!content) return null;  

        return (
          <Paper 
            key={index} 
            elevation={0} 
            sx={{ 
              mb: 1, 
              p: 2, 
              border: '1px solid #e0e0e0',
              borderRadius: '4px'
            }}
          >
            <Grid container spacing={2} alignItems="flex-start">
              <Grid item>
                <Avatar sx={{ 
                  bgcolor: 'transparent', 
                  width: 24, 
                  height: 24 
                }}>
                  <AutoAwesomeIcon sx={{ color: '#666', fontSize: 20 }} />
                </Avatar>
              </Grid>
              <Grid item xs>
                <Typography 
                  variant="subtitle1" 
                  sx={{ 
                    fontWeight: 600, 
                    color: '#333',
                    fontSize: '14px',
                    mb: 1
                  }}
                >
                  {section.title}
                </Typography>
                <Typography 
                  variant="body2" 
                  sx={{ 
                    color: '#666',
                    fontSize: '14px'
                  }}
                >
                  {content}
                </Typography>
              </Grid>
            </Grid>
          </Paper>
        );
      })}
    </Box>
  );
};

export default FeedBackAndSummary;
